// Balance memberships, in one place.
//
// The dashboard offer and the checkout modal both read this, so a plan can
// never be sellable on one screen and priceless on the other — the checkout
// carried its own map of the legacy plans only, so a Growth purchase opened a
// modal with no price in it.
//
// `key` is the plan key the API expects. These are deliberately NOT the legacy
// starter/basic/pro keys: nothing that reads a legacy plan name (the delivery
// cron, included auto-likes, the legacy boost rate) can match them, which is
// what keeps existing subscribers untouched by anything sold here.
//
// Server-side these are priced by `prices` in routes/purchase.js and granted by
// MEMBERSHIP_BALANCE — the figures below are display only and must match.
export const MEMBERSHIPS = [
	{ key: 'growth', price: 79, balance: 105 },
	{ key: 'expert', price: 149, balance: 220, featured: true },
];

export const membershipFor = (key) => MEMBERSHIPS.find((m) => m.key === key);

// What the member effectively saves, derived from the plan's own two numbers
// rather than stated separately, so the claim cannot drift from the offer.
// Growth: 1 - 79/105 = 24.8%. Expert: 1 - 149/220 = 32.3%.
export const effectiveDiscount = (plan) => Math.round((1 - plan.price / plan.balance) * 1000) / 10;
